module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/4-01973a4a8536a4b7430b447112b7b64c.png";